import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HeroCarousel } from 'site-modules/shared/components/hero-carousel/hero-carousel';

export class DealerCarouselWrapper extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.slides !== this.props.slides;
  }

  render() {
    const { dealerId, slides, isMobile, setCurrentSlide } = this.props;
    const customEventData = {
      partner_id: dealerId,
    };
    return (
      <HeroCarousel
        className="dealer-photos-carousel text-white edm-entry"
        arrows={!isMobile && slides.length > 1}
        data-tracking-parent="edm-entry-dealer-photos-carousel"
        beforeChange={setCurrentSlide}
        slides={slides}
        lazyLoad={false}
        customEventData={customEventData}
        infinite={false}
      />
    );
  }
}

DealerCarouselWrapper.propTypes = {
  dealerId: PropTypes.number,
  slides: PropTypes.arrayOf(PropTypes.element).isRequired,
  isMobile: PropTypes.bool,
  setCurrentSlide: PropTypes.func,
};

DealerCarouselWrapper.defaultProps = {
  dealerId: null,
  tagList: [],
  isMobile: false,
  setCurrentSlide: null,
};
